'use client'

import { show as showIntercom } from '@intercom/messenger-js-sdk'

import { SOCIAL_CONFIG } from '@/lib/configs/social-config'

/** X (Twitter) logo, drawn in currentColor. */
export function XLogoIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 18 18" fill="none" aria-hidden="true" className={className}>
      <path
        d="M12.4507 3.57617H14.2908L10.2707 8.17081L15 14.4231H11.297L8.39674 10.6311L5.07814 14.4231H3.23696L7.53677 9.5086L3 3.57617H6.79696L9.41857 7.04218L12.4507 3.57617ZM11.8049 13.3217H12.8245L6.24293 4.6197H5.14878L11.8049 13.3217Z"
        fill="currentColor"
      />
    </svg>
  )
}

/** LinkedIn logo, drawn in currentColor. */
export function LinkedInLogoIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 18 18" fill="none" aria-hidden="true" className={className}>
      <path
        d="M15 14.734V10.2971C15 7.91991 13.7312 6.81375 12.0387 6.81375C10.673 6.81375 10.0613 7.56493 9.72081 8.09198V6.99522H7.14845C7.18243 7.72181 7.14845 14.734 7.14845 14.734H9.72081V10.412C9.72081 10.1814 9.73744 9.95003 9.8054 9.78519C9.9912 9.32321 10.4141 8.8446 11.1248 8.8446C12.056 8.8446 12.4284 9.55384 12.4284 10.5942V14.7347L15 14.734ZM4.438 5.93895C5.3345 5.93895 5.89336 5.34394 5.89336 4.60144C5.87673 3.84231 5.3345 3.26465 4.45463 3.26465C3.57477 3.26465 3 3.84231 3 4.60144C3 5.34466 3.55814 5.93895 4.4221 5.93895H4.438ZM5.72418 14.734V6.99522H3.15255V14.734H5.72418Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const SOCIAL_LINKS = [
  { id: 'x', label: 'X', href: SOCIAL_CONFIG.twitter, icon: XLogoIcon },
  { id: 'linkedin', label: 'LinkedIn', href: SOCIAL_CONFIG.linkedin, icon: LinkedInLogoIcon },
] as const

/** Opens the Intercom messenger. */
export function openSupportChat() {
  showIntercom()
}
